function requiredEnv(name: string): string {
    const value = import.meta.env[name];
    if (!value) {
        throw new Error(`Environment variable ${ name } is required but not set.`);
    }
    return value;
}

export const config = {
    env: import.meta.env.VITE_ENV || "dev",
    apiBase: requiredEnv("VITE_API_URL"),
    bucketBase: requiredEnv("VITE_BUCKET_URL"),
};

export function isDevEnv(): boolean {
    return config.env === "development";
}

export function bucketMaterials(): string { return `${ config.bucketBase }${ isDevEnv() ? "shaders_playcanvas" : "materials" }/`; }
export function bucketTextures(): string { return `${ config.bucketBase }${ isDevEnv() ? "tex_playcanvas" : "textures" }/`; }
export function bucketModels(): string { return `${ config.bucketBase }${ isDevEnv() ? "composante_playcanvas" : "mesh" }/`; }
export function bucketFloorplans(): string { return `${ config.bucketBase }${ isDevEnv() ? "floorplans_playcanvas" : "floorplans" }/`; }
